import { GearSix } from '@phosphor-icons/react';
import { Space, Typography } from 'antd';

/** AppHeader left row on all /app/settings routes. */
export function SettingsHeaderLead() {
  return (
    <Space size="small" align="center">
      <GearSix size={20} />
      <Typography.Text strong style={{ fontSize: 14, lineHeight: 1 }}>
        Settings
      </Typography.Text>
    </Space>
  );
}
